import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';




export default withStyles((theme) => ({
    root: {     
        fontWeight: 'bold',
        fontSize: 15,
        color: '#201F1F',
        marginBottom: 15
    },  
}))(InputLabel);


